import type { VoidFunctionComponent } from 'react';
import styles from './PortalSettingsBanner.module.less';

type Props = {
  displayText: string;
};

/**
 * PortalSettingsBanner is a generic warning banner to display information
 * about the current state of the RGs portal visibility and token settings.
 */
const PortalSettingsBanner: VoidFunctionComponent<Props> = ({ displayText }) => {
  return (
    <div className={styles.banner}>
      {displayText}
    </div>
  );
};

export default PortalSettingsBanner;
